/**
 * @generated SignedSource<<8917e4ddcaacd78f560d12aeb2230cd7>>
 * @relayHash dcfa0d470157834356ab5b2a89a0b434
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a431499d34cb929df07363fc6b1ae38c42e0e5e94de697d46d6813fc86b64646

import type { ConcreteRequest, Query } from 'relay-runtime';
export type helpCenterAuthProviderQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type helpCenterAuthProviderQuery$data = {
  readonly helpLayout: {
    readonly mediaConfig: {
      readonly asapIssuer: string;
      readonly mediaToken: string;
      readonly mediaUrl: string;
    };
  } | null | undefined;
};
export type helpCenterAuthProviderQuery = {
  response: helpCenterAuthProviderQuery$data;
  variables: helpCenterAuthProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "parentAri",
    "variableName": "helpCenterAri"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v5 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
},
v6 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "helpCenterAuthProviderQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v3/*: any*/),
              "concreteType": "HelpLayoutMediaConfig",
              "kind": "LinkedField",
              "name": "mediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v4/*: any*/),
                  "action": "THROW",
                  "path": "helpLayout.mediaConfig.mediaToken"
                },
                {
                  "kind": "RequiredField",
                  "field": (v5/*: any*/),
                  "action": "THROW",
                  "path": "helpLayout.mediaConfig.mediaUrl"
                },
                {
                  "kind": "RequiredField",
                  "field": (v6/*: any*/),
                  "action": "THROW",
                  "path": "helpLayout.mediaConfig.asapIssuer"
                }
              ]
            },
            "action": "THROW",
            "path": "helpLayout.mediaConfig"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "helpCenterAuthProviderQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "HelpLayoutMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a431499d34cb929df07363fc6b1ae38c42e0e5e94de697d46d6813fc86b64646",
    "metadata": {},
    "name": "helpCenterAuthProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8d55388dabe06015bee0ae2811adc84a";

export default node;
